<template>
  <!--
    	作者：kmdshop
    	时间：2020-06-20
    	描述：diy组件-参数设置-搜索栏
    -->
  <div>
    <div class="common-form"><span>{{ curItem.name }}</span></div>
     <el-form size="small" :model="curItem" label-width="100px">
       <el-form-item label="提示文字：">
         <el-input v-model="curItem.params.placeholder"></el-input>
       </el-form-item>
       <el-form-item label="搜索框样式：">
         <el-radio-group v-model="curItem.style.searchStyle">
             <el-radio :label="3">方形</el-radio>
             <el-radio :label="6">圆角</el-radio>
             <el-radio :label="9">圆弧</el-radio>
           </el-radio-group>
       </el-form-item>
       <el-form-item label="文字对齐：">
         <el-radio-group v-model="curItem.style.textAlign">
             <el-radio :label="3">居左</el-radio>
             <el-radio :label="6">居中</el-radio>
             <el-radio :label="9">居右</el-radio>
           </el-radio-group>
       </el-form-item>

       <el-form-item label="顶部距离：">
         <el-input v-model="curItem.params.top_rpx" style="width: 200px;"></el-input>rpx
       </el-form-item>


       <el-form-item label="搜索框宽度：">
         <el-input v-model="curItem.params.width"  style="width: 200px;"></el-input>%
       </el-form-item>


       <!-- 搜索栏图标 -->
       <el-form-item label="左侧图标：">
         <el-radio-group v-model="curItem.params.icon_show">
           <el-radio :label="1">显示</el-radio>
           <el-radio :label="0">隐藏</el-radio>
         </el-radio-group>
       </el-form-item>


       <el-form-item label="是否显示logo：">
         <el-radio-group v-model="curItem.params.logo_show">
           <el-radio :label="1">显示</el-radio>
           <el-radio :label="0">隐藏</el-radio>
         </el-radio-group>
       </el-form-item>


       <el-form-item label="显示平台名称：">
         <el-radio-group v-model="curItem.params.text_show">
           <el-radio :label="1">显示</el-radio>
           <el-radio :label="0">隐藏</el-radio>
         </el-radio-group>
       </el-form-item> 


       <el-form-item label="平台名字颜色：">

        <div class="url-box">
              <span class="key-name">文字颜色：</span>
              <div class="d-s-c">
                <el-color-picker v-model="curItem.params.font_color"></el-color-picker>
                <el-button type="button" style="margin-left: 10px;" @click.stop="$parent.onEditorResetColor(curItem.style, 'btnColor', '#ffffff')">
                  重置
                </el-button>
              </div>
            </div>

       </el-form-item>



       <el-form-item label="显示搜索框：">
         <el-radio-group v-model="curItem.params.search_show">
           <el-radio :label="1">显示</el-radio>
           <el-radio :label="0">隐藏</el-radio>
         </el-radio-group>
       </el-form-item>





       <!--图标链接-->
       <el-form-item label="图标链接：">
           <el-input v-model="curItem.params.icon_link"></el-input>
           <div class="url-box" >
             <el-button type="primary" @click="changeLink(index)" style="margin-top:10px;">选择链接</el-button>
           </div>
       </el-form-item>

      <div class="common-form">扫一扫设置</div>


          <el-form-item label="扫一扫图标">
        <div>
          <el-button type="primary" @click="openUpload(1)">上传图片</el-button>
          <img :src="curItem.params.scan_image" class="mt10" width="120px;" style='border:1px dashed #999;'  />
        </div>
      </el-form-item>

        <el-form-item label="文字：">
         <el-input v-model="curItem.params.scan"></el-input>
       </el-form-item>

      <div class="common-form">消息设置</div>

      
          <el-form-item label="消息图标">
        <div>
          <el-button type="primary" @click="openUpload(2)">上传图片</el-button>
          <img :src="curItem.params.message_image" class="mt10" width="120px;" style='border:1px dashed #999;' />
        </div>
      </el-form-item>

              <el-form-item label="文字：">
         <el-input v-model="curItem.params.message"></el-input>
       </el-form-item>





    </el-form>

    <SetLink v-if="is_linkset" :is_linkset="is_linkset" @closeDialog="closeLinkset">选择链接</SetLink>

     <Upload v-if="isupload" :isupload="isupload" @returnImgs="returnImgsFunc">上传图片</Upload>
  </div>
</template>

<script>
  import Upload from '@/components/file/Upload';
  import SetLink from '@/components/setlink/Setlink';
  export default {
    components: {
      Upload,
      SetLink,
    },
    data() {
      return {
        image_id:'',
         /*是否上传图片*/
        isupload: false,
        index: null,
        urlList : [],
        /*是否选择链接*/
        is_linkset: false,
        upload_type:1,
      };
    },
    props: ['curItem', 'selectedIndex', 'opts'],
    created() {

    },
    methods: {
      /*上传*/
      


      openUpload(e) {
        this.upload_type = e;
        this.isupload = true;
      },
      /*获取图片*/
      returnImgsFunc(e) {
        console.log('e',e)
        if (e != null && e.length > 0) {
          if(  this.upload_type  == 1){
             this.curItem.params.scan_image = e[0].file_path;
          }else  if(  this.upload_type  == 2){
              this.curItem.params.message_image = e[0].file_path;
          }
        }
      
        this.isupload = false;
      },


      /*选择链接*/
        changeLink(index) {
            this.is_linkset = true;
            this.index = index;
        },

    /*获取链接并关闭弹窗*/
      closeLinkset(e) {
          this.is_linkset = false;
          if (e) {
            this.curItem.params.icon_link = e.url
            // this.curItem.data[this.index].name = e.name
          }
      },
    }
  };
</script>

<style scoped>
  .img {
     margin-top: 10px;
   }
</style>



// WEBPACK FOOTER //
// src/views/page/page/diy/params/TopSearch.vue